import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import "./AboutPage.css";

const SKILL_GROUPS = [
  {
    cat: "frontend",
    skills: [
      "React",
      "Vue.js",
      "Angular",
      "TypeScript",
      "CSS / Sass",
      "Tailwind",
    ],
  },
  {
    cat: "backend",
    skills: [
      "Symfony",
      "Java Spring",
      "Node.js",
      "Express",
      "MySQL",
      "MongoDB",
      "PostgreSQL",
    ],
  },
  { cat: "devops", skills: ["Docker", "GitHub Actions"] },
];

function AboutPage() {
  const { t } = useApp();
  const experience = t("about.exp");
  const [activeExp, setActiveExp] = useState(0);

  return (
    <div className="about-page page-enter">
      <h1 className="syn-green" style={{ marginBottom: 16 }}>
        {t("about.title")}
      </h1>

      {/* Class declaration */}
      <div className="code-line" style={{ fontSize: 13, marginBottom: 4 }}>
        <span className="syn-pink">class&nbsp;</span>
        <span className="syn-green">TommyBoubaker&nbsp;</span>
        <span className="syn-pink"> extends&nbsp;</span>
        <span className="syn-green">FullstackDeveloper&nbsp;</span>
        <span className="syn-white"> {"{"}</span>
      </div>

      {/* Bio as constructor */}
      <div className="about-section">
        <br />
        <span className="syn-orange">"{t("about.bio_1")}</span>
        <br />
        <br />
        <span className="syn-orange">{t("about.bio_2")}"</span>
        <br />
        <br />
        <span className="syn-orange">{t("about.bio_3")}"</span>
      </div>

      {/* Skills as method */}
      <div className="about-section">
        <br />
        <h2 className="syn-const">{t("about.skills_title")} :</h2>
        <br />
        {SKILL_GROUPS.map((g) => (
          <div key={g.cat} className="code-line">
            <span className="syn-lightblue">{g.cat}</span>
            <span className="syn-white">: [</span>
            {g.skills.map((s, i) => (
              <span key={s}>
                <span className="syn-orange">"{s}"</span>
                {i < g.skills.length - 1 && (
                  <span className="syn-white">,&nbsp;</span>
                )}
              </span>
            ))}
            <span className="syn-white">],</span>
          </div>
        ))}
        <br />
      </div>

      {/* Degrees as array method */}
      <div className="about-section">
        <div className="code-line">
          <h2 className="syn-const">{t("about.education_title")} :</h2>
        </div>
        <br />
        {t("about.degrees").map((d, i) => (
          <div key={i} className="degree-line">
            <span className="syn-yellow">{d.period}&nbsp;</span>
            <span className="syn-orange">"{d.institution}"&nbsp;</span>
            <span className="syn-green">{d.title}</span>
            {i === t("about.degrees").length - 1 && (
              <span className="syn-white"></span>
            )}
          </div>
        ))}
      </div>

      {/* Experience as array method */}
      <div className="about-section">
        <div className="code-line">
          <h2 className="syn-const">{t("about.experience_title")} :</h2>
        </div>
        <br />

        {/* Experience tabs */}
        <div className="exp-tabs">
          {Array.isArray(experience) &&
            experience.map((exp, i) => (
              <button
                key={i}
                className={`exp-tab${activeExp === i ? " exp-tab--active" : ""}`}
                onClick={() => setActiveExp(i)}
              >
                <span className="syn-orange">"{exp.company}"</span>
              </button>
            ))}
        </div>

        {Array.isArray(experience) && experience[activeExp] && (
          <div className="exp-detail">
            <br />
            <div className="code-line">
              <span className="syn-lightblue">role</span>
              <span className="syn-white">:&nbsp;</span>
              <span className="syn-orange">"{experience[activeExp].role}"</span>
            </div>
            <div className="code-line">
              <span className="syn-lightblue">company</span>
              <span className="syn-white">:&nbsp;</span>
              <span className="syn-orange">
                "{experience[activeExp].company}"
              </span>
            </div>
            <div className="code-line">
              <span className="syn-lightblue">period</span>
              <span className="syn-white">:&nbsp;</span>
              <span className="syn-orange">
                "{experience[activeExp].period}"
              </span>
            </div>
            <div className="code-line">
              <span className="syn-lightblue">desc</span>
              <span className="syn-white">:&nbsp;</span>
              <span className="syn-orange">"{experience[activeExp].desc}"</span>
            </div>
          </div>
        )}
        {/* Closing brace */}
        <div className="code-line" style={{ fontSize: 13, marginTop: 8 }}>
          <span className="syn-white">{"}"}</span>
        </div>
      </div>

      {/* CV download as method */}
      <div className="about-section">
        <br />
        <div className="code-line">
          <h2 className="syn-yellow">CV :</h2>
        </div>
        <div className="code-line">
          <a
            href="Tommy-BOUBAKER-CV-FullStack.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="about-cv-link"
          >
            <span className="syn-yellow">{t("about.download_cv")}</span>
          </a>
        </div>
      </div>

      {/* ContactMe method */}
      <div className="about-section">
        <br />
        <div className="code-line">
          <h2 className="syn-yellow">Contact :</h2>
        </div>
        <div className="code-line">
          <a
            href="mailto:tommy.boubaker@free.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="about-cv-link"
          >
            <span className="syn-orange">"mailto:tommy.boubaker@free.fr"</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
